angular.module('impactx.product').controller('LastOrderedProductsCtrl', ['$scope', 'dataGen', LastOrderedProductsCtrl]);

function LastOrderedProductsCtrl($scope, dataGen) {
    dataGen.getData($scope, {withoutDateRangeFilter: true}, '/product/orderedproducts');
}